export const GET_NOA_REQUEST_DETAILS = "GET_NOA_REQUEST_DETAILS";
export const GET_NOA_PREVIEW_URL = "GET_NOA_PREVIEW_URL";
export const GET_NOA_REQUESTER_DETAILS = "GET_NOA_REQUESTER_DETAILS";
const getters = {
  [GET_NOA_REQUEST_DETAILS]: state => {
    const {
      applicationRequestId,
      createdAt,
      updatedAt,
      status,
      requestId,
      type
    } = state.clientApplicationRequest;
    return {
      applicationRequestId,
      createdAt,
      updatedAt,
      status,
      requestId,
      type
    };
  },
  [GET_NOA_REQUESTER_DETAILS]: state => {
    var _metadata$signers;
    const {
      metadata
    } = state.clientApplicationRequest;
    return (metadata == null ? void 0 : (_metadata$signers = metadata.signers) == null ? void 0 : _metadata$signers[0]) || {};
  },
  [GET_NOA_PREVIEW_URL]: state => state.clientApplicationRequest.url || ""
};
export default getters;